import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDashboards = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "100%",
	height: "100%",
	viewBox: "0 0 25 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.5 3V20C1.5 20.2652 1.60536 20.5196 1.79289 20.7071C1.98043 20.8946 2.23478 21 2.5 21H22.5C22.7652 21 23.0196 20.8946 23.2071 20.7071C23.3946 20.5196 23.5 20.2652 23.5 20V3H1.5ZM15.5 18H3.5V8H15.5V18ZM21.5 18H16.5V8H21.5V18ZM8.12 10.44L10.79 13.35L12.91 10.65L14.09 11.57L10.88 15.67L8.21 12.76L6.09 15.46L4.91 14.54L8.12 10.44ZM21.5 5V7H3.5V5H21.5Z",
		fill: "currentColor"
	})
});
export default SvgDashboards;
